import styled from '@emotion/styled';
import { Column, HeadlineSmall, BodyMedium } from '../../styles';
import { shouldForwardProps } from '../../utils';

const TestimonialCardContainer = styled(Column, shouldForwardProps)<{ index: number }>`
    background-color: ${({ theme, index }) =>
        index % 2 === 0 ? theme.colors.onSecondaryContainer : theme.colors.background};
`;

const TestimonialCardContent = styled(Column, shouldForwardProps)`
    align-self: center;
    gap: ${({ theme }) => theme.spacing(2)};
`;

const Quote = styled(HeadlineSmall, shouldForwardProps)<{ noClamp?: boolean }>`
    display: -webkit-box;
    -webkit-line-clamp: ${({ noClamp }) => (noClamp ? 'none' : 4)};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    max-width: 644px;
`;

const TestimonialCardText = styled(BodyMedium, shouldForwardProps)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export { TestimonialCardContainer, TestimonialCardContent, Quote, TestimonialCardText };
